export const BARRY_PROMPT_SUGGESTIONS = [
	{ title: 'Compare my revenue from this month to last month' },
	{ title: 'Show me a list of my top selling services' },
	{ title: 'Which promotions generate the most revenue?' },
	{ title: 'How many invoices are currently unpaid?' },
];
